/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import { Typography } from '@mui/material';
import React, { useState } from 'react';
import { Box } from '@mui/system';
import RobotFindSelectForm from '../RobotFindSelectForm';

const SubUserAddForm = (props) => {
  const {
    id,
    selected,
    readOnly,
    mini,
    searchedRobot,
    onSearch,
    onChangeSerial,
  } = props;
  const [input, setInputSerial] = useState(null);
  const onChange = (e) => {
    const {
      target: { value },
    } = e;
    setInputSerial(value);
    onSearch(id, value);
  };
  const onSelect = (robot) => {
    onChangeSerial('select', robot.row);
    setInputSerial('');
  };
  const onDeselect = (rId) => {
    onChangeSerial('deselect', rId);
  };

  return (
    <Box>
      <Typography variant="subtitle2">
        {readOnly ? '사용 중인 로봇' : '로봇 검색 및 선택'}
      </Typography>
      <RobotFindSelectForm
        {...{
          selected,
          readOnly,
          onDeselect,
          onChange,
          input,
          mini,
          onSelect,
          list: searchedRobot,
        }}
      />
    </Box>
  );
};

export default SubUserAddForm;
